// Annual counseling meeting documentation for
// assistant and associate professors

import { CCSetup } from "../../cclib/CCSetup";
import { CCStructure } from "../../cclib/CCStructure";
import { assistantStructure } from "./structure";

import dayjs from "dayjs";
import LocalizedFormat from "dayjs/plugin/localizedFormat.js";
import { CCIcon } from "../../cclib/components/UI";
import { reputationSetup, reputationUpdate } from "../afcs/tables";
import {
  cleanUpCheckboxes,
  cleanUpContributionSection,
  copyLastYearContribValues,
  outputContribution,
  setupDeptEMForm,
  updateContributionTotals,
  watchContributionInputs
} from "../shared/util";
dayjs.extend(LocalizedFormat);

import { DISABLE_EMAILS } from "../stanford_em";

export const assistantDataPrefix = "stanford_em_assistant_";

function cleanUpTopics() {
  const containers = $(".confCheck[data-key*='topic_']").parent();
  containers.css("margin-bottom", "0");
}

export function addPersistentAssistantHeader(cc: CCSetup) {
  cc.addButton(
    "primary",
    CCIcon("download") +
      "<span>Assistant and Associate Professor Counseling Form</span>",
    {
      relative: "after",
      selector: ".downloadDataSummary"
    },
    "downloadAssistantAnnualCounseling",
    () => outputAssistant(cc)
  );
}
export function updateAssistant(cc: CCSetup) {
  if (cc.uninitializedYearState) {
    copyLastYearContribValues(cc);
  }
  updateContributionTotals(cc);
}
export function outputAssistant(cc: CCSetup) {
  const data = cc.newDef.career[cc.viewYear].data;
  const dataOverride = {};
  const totals = updateContributionTotals(cc);
  dataOverride["contrib_total"] = totals[0];
  dataOverride["contrib_total_change"] = totals[1];

  cc.conferenceExport(
    "stanford_em_assistant.docx",
    `Form_Assistant_and_Associate Annual_Counseling_${cc.cvOwner.name}_${dayjs(new Date()).format("MM-DD-YYYY")}`,
    {
      ...dataOverride,
      ...outputContribution(cc)
    },
    () => ""
  );
}
export function setupAssistant(cc: CCSetup) {
  const structure = new CCStructure(assistantStructure);
  cc.generateFieldsFromStructure(structure, cc.ccRoot, false);
  cleanUpContributionSection(cc);
  $("#contrib-container").css("margin-bottom", "10px");
  updateContributionTotals(cc);
  watchContributionInputs(cc);
  cleanUpCheckboxes();
  cleanUpTopics();

  cc.defineCustomSection(
    "custom-reputation",
    (container: JQuery, thisCC: CCSetup) =>
      reputationSetup(container, thisCC, true),
    (table, cc) => reputationUpdate(table, cc, "mentor")
  );

  setupDeptEMForm(cc, "CE");

  cc.setValueIfUndefined(
    "process_begin",
    dayjs(
      cc.newDef.career[cc.viewYear].data[
        cc.dataPrefix + "current_appointment_end_date"
      ]
    )
      .subtract(1, "year")
      .format("YYYY-MM-DD")
  );

  updateContributionTotals(cc);
  cc.appendStatusButtons(false, DISABLE_EMAILS);
  cc.update(cc.struct.structure);
  cc.contextMethods.updateLayout();
}
